import { isValidEmptyValue } from '../../index'

export const getDurationSchema = (inputString: any, schema: any) => {
  if (typeof schema.greater_or_equal !== 'undefined') {
    inputString = inputString.test('greater_or_equal', (val: any) => {
      if (!schema.is_required && isValidEmptyValue(val)) {
        return true
      }
      return Number(val) >= schema.greater_or_equal
    })
  }
  if (typeof schema.greater_than !== 'undefined') {
    inputString = inputString.test('greater_than', (val: any) => {
      if (!schema.is_required && isValidEmptyValue(val)) {
        return true
      }
      return Number(val) > schema.greater_than
    })
  }
  if (typeof schema.less_or_equal !== 'undefined') {
    inputString = inputString.test('less_or_equal', (val: any) => {
      if (!schema.is_required && isValidEmptyValue(val)) {
        return true
      }
      return Number(val) <= schema.less_or_equal
    })
  }
  if (typeof schema.less_than !== 'undefined') {
    inputString = inputString.test('less_than', (val: any) => {
      if (!schema.is_required && isValidEmptyValue(val)) {
        return true
      }
      return Number(val) < schema.less_than
    })
  }
  if (schema.is_required) {
    inputString = inputString
      .test(
        'duration',
        'int',
        (val: any) =>
          Number.isInteger(Number(val)) && !(val || '').includes('.')
      )
      .test('positive', 'int', (val: any) => Number(val) >= 0)
      .required()
  }
  if (!schema.is_required) {
    inputString = inputString
      .notRequired()
      .nullable()
      .transform((_: any, val: any) => String(val) || null)
      .test(
        'positive',
        'int',
        (val: any) => Number(val) >= 0 || isValidEmptyValue(val)
      )
  }

  return inputString
}
